import * as actions from './actions';
import { LoadingAction } from '../common/loading-action';
import { ErrorAction } from '../common/error-action';
import { Roster } from '@services/rosters/types/roster';
import { Action } from 'redux';
import { RosterRelation } from '@services/rosters/types/roster-relation';
import { RosterOperator } from '@services/rosters/types/roster-operator';
import SimpleArtist from '@common/types/artist/simple-artist';
import { NewRosterRelation } from '@services/rosters/types/new-roster-relation';

export class GetRosters implements LoadingAction {
  readonly type = actions.GET_ROSTERS;
  readonly isLoading = true;

  constructor(public labelId: string) {}
}

export class GetRostersSuccess implements LoadingAction {
  readonly type = actions.GET_ROSTERS_SUCCESS;
  readonly isLoading = false;

  constructor(public list: Roster[]) {}
}

export class GetRostersError implements ErrorAction {
  readonly type = actions.GET_ROSTERS_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class ListRosterArtists implements LoadingAction {
  readonly type = actions.LIST_ROSTER_ARTIST;
  readonly isLoading = true;

  constructor(public rosterId: string, public labelId: string) {}
}

export class ListRosterArtistsSuccess implements LoadingAction {
  readonly type = actions.LIST_ROSTER_ARTIST_SUCCESS;
  readonly isLoading = false;

  constructor(public rosterId: string, public list: RosterRelation[]) {}
}

export class ListRosterArtistsError implements ErrorAction {
  readonly type = actions.LIST_ROSTER_ARTIST_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class CreateRoster implements LoadingAction {
  readonly type = actions.CREATE_ROSTER;
  readonly isLoading = true;

  constructor(
    public labelId: string,
    public rosterName: string,
    public artists: SimpleArtist[]
  ) {}
}

export class CreateRosterSuccess implements LoadingAction {
  readonly type = actions.CREATE_ROSTER_SUCCESS;
  readonly isLoading = false;

  constructor(public roster: Roster, public artistsToAttach: SimpleArtist[]) {}
}

export class CreateRosterError implements ErrorAction {
  readonly type = actions.CREATE_ROSTER_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class UpdateRoster implements LoadingAction {
  readonly type = actions.UPDATE_ROSTER;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public roster: Roster, public artists?: SimpleArtist[]) {}
}

export class UpdateRosterSuccess implements LoadingAction {
  readonly type = actions.UPDATE_ROSTER_SUCCESS;
  readonly isLoading = false;

  constructor(public roster: Roster, public artistsToAttach?: SimpleArtist[]) {}
}

export class UpdateRosterError implements ErrorAction {
  readonly type = actions.UPDATE_ROSTER_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class UpdateRosterRelation implements LoadingAction {
  readonly type = actions.UPDATE_ROSTER_RELATION;
  readonly isLoading = true;

  constructor(public rosterRelation: RosterRelation) {}
}

export class UpdateRosterRelationSuccess implements LoadingAction {
  readonly type = actions.UPDATE_ROSTER_RELATION_SUCCESS;
  readonly isLoading = false;

  constructor(public rosterRelation: RosterRelation) {}
}

export class UpdateRosterRelationError implements ErrorAction {
  readonly type = actions.UPDATE_ROSTER_RELATION_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}
export class DeleteRoster implements Action {
  readonly type = actions.DELETE_ROSTER;

  constructor(public rosterId: string, public labelId: string) {}
}

export class DeleteRosterSuccess implements LoadingAction {
  readonly type = actions.DELETE_ROSTER_SUCCESS;
  readonly isLoading = false;

  constructor(public rosterId: string) {}
}

export class DeleteRosterError implements ErrorAction {
  readonly type = actions.DELETE_ROSTER_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class AttachToRoster implements LoadingAction {
  readonly type = actions.ATTACH_TO_ROSTER;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public relation: NewRosterRelation) {}
}

export class AttachToRosterSuccess implements LoadingAction {
  readonly type = actions.ATTACH_TO_ROSTER_SUCCESS;
  readonly isLoading = false;

  constructor(public relation: RosterRelation) {}
}

export class AttachToRosterError implements ErrorAction {
  readonly type = actions.ATTACH_TO_ROSTER_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class RemoveFromRoster implements LoadingAction {
  readonly type = actions.REMOVE_FROM_ROSTER;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public relation: RosterRelation) {}
}

export class RemoveFromRosterSuccess implements LoadingAction {
  readonly type = actions.REMOVE_FROM_ROSTER_SUCCESS;
  readonly isLoading = false;

  constructor(public relation: RosterRelation) {}
}

export class RemoveFromRosterError implements ErrorAction {
  readonly type = actions.REMOVE_FROM_ROSTER_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class ListRosterOperators implements LoadingAction {
  readonly type = actions.LIST_ROSTER_OPERATORS;
  readonly isLoading = true;

  constructor(public rosterId: string) {}
}

export class ListRosterOperatorsSuccess implements LoadingAction {
  readonly type = actions.LIST_ROSTER_OPERATORS_SUCCESS;
  readonly isLoading = false;

  constructor(public rosterId: string, public list: RosterOperator[]) {}
}

export class ListRosterOperatorsError implements ErrorAction {
  readonly type = actions.LIST_ROSTER_OPERATORS_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class CreateRosterOperator implements LoadingAction {
  readonly type = actions.CREATE_ROSTER_OPERATOR;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(
    public rosterId: string,
    public userName: string,
    public userId: string
  ) {}
}

export class CreateRosterOperatorSuccess implements LoadingAction {
  readonly type = actions.CREATE_ROSTER_OPERATOR_SUCCESS;
  readonly isLoading = false;
  readonly mainLoader = true;

  constructor(public rosterId: string, public operator: RosterOperator) {}
}

export class CreateRosterOperatorError implements ErrorAction {
  readonly type = actions.CREATE_ROSTER_OPERATOR_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class RemoveOperatorFromRoster implements LoadingAction {
  readonly type = actions.REMOVE_OPERATOR_FROM_ROSTER;
  readonly isLoading = true;

  constructor(public rosterId: string, public operatorId: string) {}
}

export class RemoveOperatorFromRosterSuccess implements LoadingAction {
  readonly type = actions.REMOVE_OPERATOR_FROM_ROSTER_SUCCESS;
  readonly isLoading = false;

  constructor(public rosterId: string, public operatorId: string) {}
}

export class RemoveOperatorFromRosterError implements ErrorAction {
  readonly type = actions.REMOVE_OPERATOR_FROM_ROSTER_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export type RostersActions =
  | GetRosters
  | GetRostersSuccess
  | GetRostersError
  | UpdateRoster
  | UpdateRosterSuccess
  | UpdateRosterError
  | DeleteRoster
  | DeleteRosterSuccess
  | DeleteRosterError
  | AttachToRoster
  | AttachToRosterSuccess
  | AttachToRosterError
  | RemoveFromRoster
  | RemoveFromRosterSuccess
  | RemoveFromRosterError
  | CreateRoster
  | CreateRosterSuccess
  | CreateRosterError
  | ListRosterArtists
  | ListRosterArtistsSuccess
  | ListRosterArtistsError
  | UpdateRosterRelation
  | UpdateRosterRelationSuccess
  | UpdateRosterRelationError
  | ListRosterOperators
  | ListRosterOperatorsSuccess
  | ListRosterOperatorsError
  | CreateRosterOperator
  | CreateRosterOperatorSuccess
  | CreateRosterOperatorError
  | RemoveOperatorFromRoster
  | RemoveOperatorFromRosterSuccess
  | RemoveOperatorFromRosterError;
